export const CHAT_MESSAGE_ROW_PRESETS = {
  im: {
    row: 'im-row',
    rowSelf: 'artist',
    rowOther: 'admin',
    body: 'im-col',
    sender: 'im-sender',
    line: 'im-line',
    read: 'im-read',
    bubble: 'chat-bubble im-bubble',
    timeWrap: 'im-meta',
    time: 'im-time',
  },
  plain: {
    row: 'chat-message-wrapper',
    rowSelf: 'align-right',
    rowOther: 'align-left',
    body: 'message-body',
    sender: 'message-sender-label',
    line: 'message-content-row',
    read: 'read-count',
    bubble: 'chat-bubble',
    timeWrap: '',
    time: 'message-time-label',
  },
  adminIndividual: {
    row: 'im-row',
    rowSelf: 'admin-self',
    rowOther: 'admin-other',
    body: 'im-col',
    sender: 'im-sender',
    line: 'im-line',
    read: 'im-read',
    bubble: 'admin-message-chat-message',
    timeWrap: 'message-meta',
    time: 'message-time',
  },
  artistIndividual: {
    row: 'im-row',
    rowSelf: 'artist',
    rowOther: 'admin',
    body: 'im-col',
    sender: 'im-sender',
    line: 'im-line',
    read: 'im-read',
    bubble: 'artist-message-chat-message im-bubble',
    timeWrap: 'im-meta',
    time: 'im-time',
  },
  chatIntro: {
    row: 'chat-intro-guidance-row',
    rowSelf: '',
    rowOther: '',
    body: 'chat-intro-guidance-body',
    sender: 'chat-intro-guidance-sender',
    line: 'chat-intro-guidance-line',
    read: 'chat-intro-guidance-read',
    bubble: 'chat-intro-guidance-bubble',
    timeWrap: '',
    time: 'chat-intro-guidance-time',
  },
};

export function resolveChatMessageRowPreset(preset, fallbackVariant = 'im') {
  if (preset && CHAT_MESSAGE_ROW_PRESETS[preset]) {
    return CHAT_MESSAGE_ROW_PRESETS[preset];
  }

  return CHAT_MESSAGE_ROW_PRESETS[fallbackVariant] || CHAT_MESSAGE_ROW_PRESETS.im;
}
